import React from "react";
import * as styles from "./Button.module.css";

function Button({ className = "", children, varient, ...rest }) {
  const combinedClassName = `${styles.commonButtonClass} ${
    styles[varient] || ""
  } ${className}`;

  return (
    <button className={combinedClassName.trim()} {...rest}>
      {children}
    </button>
  );
}

export default Button;
